import { b64DecodeUnicode } from "../util";
import React, { useMemo } from "react";

export const DecodedText = ({ text }) => {
  const decoded = useMemo(
    () => window.decodeURIComponent(b64DecodeUnicode(text)),
    [text]
  );
  const x = window.innerWidth * 0.1;
  const y = window.innerHeight * 0.1;

  // Fill 95% of screen width
  const screenWidth = window.innerWidth;
  const usableWidth = screenWidth * 0.95;
  const estimatedCharWidthRatio = 0.6;

  // Estimate how many characters can fit per line at a given fontSize
  // We choose fontSize first, then adjust how many characters to wrap at
  const fontSize = usableWidth * 0.06; // ~6% of screen width in pixels
  const estimatedCharWidth = estimatedCharWidthRatio * fontSize;
  const maxCharsPerLine = Math.floor(usableWidth / estimatedCharWidth);
  const lineHeightEm = 1.2;

  // Word-aware wrapping
  const words = decoded.split(/\s+/);
  const lines = [];
  let currentLine = "";

  for (let word of words) {
    if (word.length > maxCharsPerLine) {
      if (currentLine) {
        lines.push(currentLine);
        currentLine = "";
      }
      for (let i = 0; i < word.length; i += maxCharsPerLine) {
        lines.push(word.slice(i, i + maxCharsPerLine));
      }
    } else {
      if ((currentLine + " " + word).trim().length <= maxCharsPerLine) {
        currentLine = currentLine ? currentLine + " " + word : word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
  }
  if (currentLine) lines.push(currentLine);

  return (
    <text
      fontSize={fontSize}
      x={x}
      y={y}
      textAnchor="start"
      dominantBaseline="hanging"
    >
      {lines.map((line, i) => (
        <tspan key={i} x={x} dy={i === 0 ? "0" : `${lineHeightEm}em`}>
          {line}
        </tspan>
      ))}
    </text>
  );
};
